import { axiosInstance, isAuthenticated } from '@/service/axios';
import { IContactForm, INotification, IUser, PaginatedResponse } from '@/service/types';
import { cleanCPFCNPJ, getPaginatedEndpoint, snakeCaseDictToCamelCaseDict } from '@/service/utils';

export async function getUserByCode(code: string): Promise<IUser> {
  code = cleanCPFCNPJ(code);
  return axiosInstance.get(`/user/cpf/${code}/`).then(({ data }) => snakeCaseDictToCamelCaseDict(data) as IUser);
}

export async function getProfile(): Promise<IUser | null> {
  if (!isAuthenticated()) return null;
  return axiosInstance.get(`/profile/`).then(({ data }) => snakeCaseDictToCamelCaseDict(data) as IUser);
}

export async function updateProfile(data: Record<string, string | boolean>): Promise<IUser | null> {
  if (!isAuthenticated()) return null;
  return axiosInstance.patch(`/profile/my/`, data).then(({ data }) => snakeCaseDictToCamelCaseDict(data) as IUser);
}

export async function getNotifications(): Promise<PaginatedResponse<INotification>> {
  return getPaginatedEndpoint(`/notifications/`);
}

export async function sendContactMessage(data: IContactForm): Promise<null> {
  return axiosInstance.post(`/contact/`, data);
}

export async function buyProduct(
  discount_id: string,
  quantity: number
): Promise<{
  url: string;
  id: number;
}> {
  return axiosInstance.post(`/sales/buy/`, {
    discount_id,
    quantity,
  });
}

export const getSaleStatus = async (id: string) => {
  if (!id) return [];
  const url = `/sales?vindi_bill_id=${id}`;

  return await axiosInstance.get(url).then(({ data }) => {
    if (data.results.length > 0) {
      return data.results.at(0);
    }
  });
};
